export enum MobileOS {
	IOS = 'iOS',
	ANDROID = 'Android',
	NULL = '',
}

export enum ERROR_NAME {
	UNLOGGED = 'UnloggedError',
}
